export class DayViewProjectModeEntriesModel {
    constructor() {
        this.projectId = "";
        this.projectName = "";
        this.teamId = "";
        this.projectCode = 0;
        this.dayEntriesTask = [];
        this.totalTime = 0;
    }
}
export default class DayViewProjectModeEntries extends DayViewProjectModeEntriesModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
